package com.daytimegaming.ourdailyfinances.domain.model

data class OptionContract(
    val contractType: String,
    val expirationDate: String,
    val strikePrice: Double,
    val underlyingSecurityTicker: String,
)

data class YieldRate(
    val percentage: Double,
    val type: String,
)

data class FixedIncome(
    val maturityDate: String?,
    val issueDate: String?,
    val faceValue: Double?,
    val yieldRate: YieldRate?,
)

data class Security(
    val securityId: String,
    val name: String?,
    val tickerSymbol: String?,
    val type: String?,
    val subtype: String?,
    val isin: String?,
    val cusip: String?,
    val sedol: String?,
    val institutionSecurityId: String?,
    val institutionId: String?,
    val proxySecurityId: String?,
    val isCashEquivalent: Boolean?,
    val closePrice: Double?,
    val closePriceAsOf: String?,
    val isoCurrencyCode: String?,
    val unofficialCurrencyCode: String?,
    val marketIdentifierCode: String?,
    val sector: String?,
    val industry: String?,
    val cfiCode: String?,
    val updateDatetime: String?,
    val optionContract: OptionContract?,
    val fixedIncome: FixedIncome?,
)

data class Holding(
    val accountId: String,
    val securityId: String,
    val security: Security?,
    val proxySecurity: Security? = null,
    val institutionPrice: Double,
    val institutionPriceAsOf: String?,
    val institutionValue: Double?,
    val costBasis: Double?,
    val quantity: Double,
    val isoCurrencyCode: String?,
)

data class InvestmentTransaction(
    val investmentTransactionId: String,
    val accountId: String,
    val securityId: String?,
    val security: Security?,
    val date: String,
    val name: String,
    val quantity: Double?,
    val amount: Double,
    val price: Double?,
    val fees: Double?,
    val type: String,
    val subtype: String?,
    val isoCurrencyCode: String?,
    val cancelTransactionId: String?,
)

data class Investments(
    val holdings: List<Holding>,
    val transactions: List<InvestmentTransaction>,
)
